module.exports = __webpack_public_path__ + "static/media/surat_keterangan.4690a089.svg";